import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card-header',
  standalone: true,
  templateUrl: './card-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-header.component.css',
})
export class CardHeaderComponent {}
